<script lang="ts">
    import Title from "../Components/Title.svelte";
    import {onMount} from "svelte";
    import GenericLoading from "../Modals/GenericLoading.svelte";
    import {alertShown, modalComponent, documentData} from "../Core/Store";
    import {handApi} from "../Core/HandApi";
    import {DocumentData} from "../Data/DocumentData";
    import GenericError from "../Modals/GenericError.svelte";
    let localDocumentData:DocumentData[] = [];

    onMount(async () => {
        modalComponent.set(GenericLoading);
        alertShown.set(true);

        if ($documentData !== null) {
            localDocumentData = $documentData;
            alertShown.set(false);
        }

        // Load in new data anyway
        let results = await handApi.getDocumentData();

        if (results === null) {
            modalComponent.set(GenericError);
            return;
        }

        documentData.set(results);
        localDocumentData = $documentData;
        alertShown.set(false);
    });

    async function download(url) {
        if (url.includes('https')) {
            window.open(url);
        } else {
            window.open(handApi.mainUrl + url);
        }
    }
</script>

<div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
    <Title textColor="text-hand-blue-500">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clip-rule="evenodd" />
        </svg>
        <span>
            Documents
        </span>
    </Title>

    {#each localDocumentData as document}
        <div class="pl-4 pr-6 py-4 mb-2 bg-white shadow rounded" on:click={() => download(document.url)}>
            <div class="mb-4 md:mb-0 flex items-center">
                {#if document.name.endsWith('.jpg') || document.name.endsWith('.png') || document.name.endsWith('.jpeg')}
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                {:else}
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                {/if}
                <h4 class="text-xs font-medium">{document.name}</h4>
            </div>
            <div class="flex items-center justify-between">
                <div class="flex items-center text-xs text-gray-500">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
                    </svg>
                    <p>{document.type}</p>
                </div>
                <div class="flex justify-end items-center space-x-2 text-sm font-medium">
                    <svg xmlns="http://www.w3.org/2000/svg" class="text-hand-blue-500 h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10" />
                    </svg>
                    <span>Download</span>
                </div>
            </div>
        </div>
    {/each}
</div>